import http from "./http";
const users = {
  getListForPage(key, order, sort, page, size) {
    return http.get(
      "user/manage/list?key=" +
        key +
        "&order=" +
        order +
        "&sort=" +
        sort +
        "&page=" +
        page +
        "&size=" +
        size
    );
  },
  insert(modal) {
    return http.post("user/manage/add",modal);
  },

  deletes(ids) {
    return http.post("user/manage/deletes?ids=" + ids);
  },

  find(words, order, sort, page, size) {
    return http.get(
      "user/manage/list?key=" +
        words +
        "&order=" +
        order +
        "&sort=" +
        sort +
        "&page=" +
        page +
        "&size=" +
        size
    );
  },
};
export default users;
